export default {
      id: "add-patient-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#add-patient",
      toString: function () {
        return this.url;
      }
    }